// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"112":"da6eb46f1b2e63ca","791":"f5c69af5a685d5dc"}[chunkId] + ".js";
};